<template>
  <tsny-modal
    :modal-id="modalId"
    modal-title="Signup Token"
    submit-button-text="OK"
    :submit-modal="() => {}"
    :reset-modal="() => {}"
  >
    <p class="tsny_text">
      Click this link if you want to complete the registration process for the
      user. Note that they will have received an email containing the same
      registration link, so if you elect to complete registration for them you
      should probably let them know. <br /><br />
      The token link will be valid to register only once, only for the email
      address from which it was generated, and only for eight hours. You will be
      unable to generate a signup token for an email address already associated
      with an existing account.
    </p>
    <a href="#" @click="toSignup">{{ signupToken }}</a></tsny-modal
  >
</template>

<script>
import TsnyModal from "../TsnyModal";
export default {
  name: "SignupTokenModal",
  components: { TsnyModal },
  props: {
    signupToken: {
      type: String,
      default: null
    }
  },
  data: () => ({
    modalId: "signupTokenModal"
  }),
  methods: {
    toSignup: function() {
      this.$router.push({
        name: "Registration",
        params: { token: this.signupToken }
      });
    }
  }
};
</script>

<style scoped>
a {
  word-wrap: break-word;
}
</style>
